import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "href", "target", "rel", "onClick"];
import styled from 'styled-components';
import { CALYPSO_MEDIUM, CALYPSO_DARK, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { lighten } from 'visitor-ui-component-library/utils/colors';
import { promptButtonBaseStyles } from '../shared/components/BasePromptButton';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickLinksButtonStyled = styled.a.withConfig({
  displayName: "QuickLinksButton__QuickLinksButtonStyled"
})(["", " background:", ";color:", ";border:1px solid ", ";cursor:pointer;text-decoration:none;&:hover:not(:disabled){color:", ";text-decoration:none;}&:visited{color:", ";}&:disabled{opacity:0.6;cursor:not-allowed;}"], promptButtonBaseStyles, WHITE, CALYPSO_DARK, CALYPSO_MEDIUM, lighten(CALYPSO_DARK, 0.1), CALYPSO_DARK);
const QuickLinksButton = _ref => {
  let {
      children,
      href,
      target = '_blank',
      rel = 'noopener noreferrer',
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(QuickLinksButtonStyled, Object.assign({
    href: href,
    target: target,
    rel: rel,
    onClick: onClick
  }, props, {
    children: children
  }));
};
QuickLinksButton.displayName = 'QuickLinksButton';
export default QuickLinksButton;